
<template>
    <div class="success-wrapper">
        <div class="suc-container">
            <p class="suc-text">支付成功！</p>
            <img :src="paySuccessSrc" alt="pay-success" />
        </div>
        <div class="btn-group">
            <div
                class="pri"
                v-if="isCombinedOrder || isOverTime"
                @click="toOrderList"
            >
                返回订单列表
            </div>
            <p class="tips" v-else>稍后会自动跳转到订单详情...</p>

            <div class="ret" @click="toHome">返回首页</div>
        </div>
    </div>
</template>

<script>
import { _auth } from "@/js/auth";
let status = 0;
export default {
    name: "PaySuccess",
    components: {},
    props: {},
    data() {
        return {
            timer: null,
            isOverTime: false,
            paySuccessSrc: "",
        };
    },
    computed: {
        orderId() {
            return this.$route.query.id;
        },
        isCombinedOrder() {
            return this.$route.query.isCombinedOrder == 1;
        },
    },
    watch: {},
    created() {
        let vm = this;
        if (sessionStorage.token) {
            if (!this.isCombinedOrder) {
                this.timer = setInterval(() => {
                    if (status > 1) {
                        clearInterval(vm.timer);
                        vm.toOrderDetail();
                        return;
                    }
                    vm.getOrderDetail();
                }, 200);
            }
        } else {
            _auth(this, () => {
                if (!this.isCombinedOrder) {
                    this.timer = setInterval(() => {
                        if (status > 1) {
                            clearInterval(vm.timer);
                            vm.toOrderDetail();
                            return;
                        }
                        vm.getOrderDetail();
                    }, 200);
                }
            });
        }
    },
    mounted() {
        let vm = this;
        setTimeout(function () {
            vm.isOverTime = true;
        }, 3000);
        this.paySuccessSrc = API.ossUrl + "yyq/pay-success.png";
    },
    destroyed() {},
    methods: {
        toOrderDetail() {
            this.$router.replace(`/orderDetail?id=${this.orderId}`);
        },
        toOrderList() {
            this.$router.replace(`/userOrderList`);
        },
        toHome() {
            this.$router.replace(`/scene`);
        },
        getOrderDetail() {
            this.$axios
                .get(
                    `${window.API.user.getOrderDetail}/${this.orderId}?token=${sessionStorage.token}`
                )
                .then(({ data }) => {
                    if (data.code == 200) {
                        status = data.data.detail.status;
                    } else {
                        clearInterval(this.timer);
                    }
                })
                .catch((err) => {
                    clearInterval(this.timer);
                });
        },
    },
};
</script>

<style scoped lang="scss">
.success-wrapper {
    min-height: 100%;
    background: #fff;
    .suc-container {
        display: flex;
        align-items: center;
        flex-direction: column;
        img {
            width: 4.72rem;
            height: 2.986667rem;
            margin-bottom: 0.72rem;
        }
        .suc-text {
            font-size: 22px;
            color: #444444;
            text-align: center;
            font-weight: bold;
            margin-bottom: 1.333333rem;
            margin-top: 2.133333rem;
        }
    }
    .btn-group {
        position: fixed;
        bottom: 2.133333rem;
        padding: 0 0.586667rem;
        width: 100%;
        .tips {
            text-align: center;
            color: rgba(245, 149, 38, 1);
            font-size: 16px;
            margin-bottom: 0.533333rem;
            font-weight: bold;
        }
        .pri {
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 16px;
            font-weight: bold;
            color: $white;
            background: linear-gradient(
                90deg,
                rgba(248, 199, 64, 1) 0%,
                rgba(245, 149, 38, 1) 100%
            );
            box-shadow: 0 0 10px 0 rgba(248, 199, 64, 1);
            border-radius: 0.6rem;
            height: 1.2rem;
            margin-bottom: 0.533333rem;
        }
        .ret {
            font-weight: bold;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 16px;
            color: #8c8c8c;
            background: $white;
            border: 1px solid #8c8c8c;
            border-radius: 0.6rem;
            height: 1.2rem;
        }
    }
}
</style>


